import { createSlice } from '@reduxjs/toolkit';

const filterSlice = createSlice({
  name: 'filter',
  initialState: {
    status: null,
    isVerified: null,
  },
  reducers: {
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setIsVerified: (state, action) => {
      state.isVerified = action.payload;
    },
    resetFilter: (state) => {
      state.status = null;
      state.isVerified = null;
    }
  }
});

export const { setStatus, setIsVerified, resetFilter } = filterSlice.actions;
export default filterSlice.reducer;